export default __webpack_public_path__ + "static/media/regulatory--low-beam-headlights--g1.f0dfd718.png";